import { AxiosError } from "axios";
import { Api } from "interfaces";

export const NETWORK_NOT_AVAILABLE: Api.ApiError = {
  detail: "Network Not Available. Could you recheck and try later?",
};

export const SERVER_ERROR: Api.ApiError = {
  detail:
    "Something went wrong on the server. We are very sorry for this. Maybe you want to try again later?",
};

export const LOGIN_FAILURE_MESSAGES: string[] = [
  "Invalid payload.",
  "Authentication credentials were not provided.",
];

export const processError = (authFailureCallback?: () => any) => ({
  response,
}: AxiosError) => {
  // Network error - no response from server.
  if (!response) {
    return {
      status: 999,
      error: { detail: "Network Issues. Try later." },
    };
  }

  // Server sent back an error
  const { status } = response;
  let error = response.data as Api.ApiError;

  const errorMessage = error.detail as string;
  if (LOGIN_FAILURE_MESSAGES.includes(errorMessage)) {
    // handle login failure
    // update store
    localStorage.removeItem("jwt");
    authFailureCallback?.();
  } else if (!error.detail && !error.non_field_errors) {
    error = { detail: response.data };
  }

  return { status, error };
};
